import React from 'react';
import { useTranslation } from 'react-i18next';

const ContactPage = ({ isOpen, onClose }) => {
        const { t } = useTranslation();
    
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            {/* Backdrop */}
            <div
                className="fixed inset-0 bg-black bg-opacity-50"
                onClick={onClose}
            />

            {/* Modal Content */}
            <div className="relative bg-white w-[90vw] max-w-lg max-h-[90vh] overflow-y-auto rounded-lg p-6 z-10">
                {/* Close Button */}
                <button
                    onClick={onClose}
                    className="absolute top-6 right-6 text-white hover:text-white/50"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>

                {/* Contact Section */}
                <div className="text-center bg-[#3c4f58] text-white p-8 rounded-lg">
                    <h2 className="text-2xl font-semibold mb-4">{t('İletişim ve Abonelik Bilgileri')}</h2>
                    <p className="mb-4 text-justify">
                    {t('about2')}
                    </p>
                    <div className="flex justify-center space-x-8">
                        <div>
                            <p className="font-semibold">{t('Email')}</p>
                            <p>info@kesifaraci.com</p>
                        </div>
                        <div>
                            <p className="font-semibold">{t('Telefon')}</p>
                            <p>+90 531 652 27 42</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactPage;
